import { render, staticRenderFns } from "./disbursement-data-modal.vue?vue&type=template&id=33326cb2&"
import script from "./disbursement-data-modal.vue?vue&type=script&lang=js&"
export * from "./disbursement-data-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports